import AdvancedSetting from './advancedSetting';

export default AdvancedSetting;